setAhoyConfig = ->
  keys = getFedoraKeys()
  if !keys
    return
  site_env = keys.env
  if site_env is "development" or site_env is "staging" then ahoy.debug()

  if keys.trackAllAhoy
    ahoy.trackAll()
  else
    if keys.trackChangesAhoy
      ahoy.trackChanges()
    if keys.trackClicksAhoy
      ahoy.trackClicks()
    if keys.trackSubmitsAhoy
      ahoy.trackSubmits()
  ahoy.trackView()

$(document).on "ready page:load", setAhoyConfig
